/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through E2E */

/**
 * The entrypoint for the WordPress frontend widget.
 */

import "@tatum/utils"; // Import once for startup polyfilling (e. g. setimmediate)
import { render } from "react-dom";
import { RootStore } from "./store";
import { Constants } from "./constants";
import React from "react";
import { XdcPaymentGateway } from "./widget/xdcPaymentGateway";
import "./style/tailwind.css";

setTimeout(() => {
    const xdcPaymentGateways = document.querySelectorAll(`div.${Constants.slug}`);
    xdcPaymentGateways.forEach((gateway) => {
        render(
            <RootStore.StoreProvider>
                <XdcPaymentGateway cartTotal={(gateway as HTMLElement).dataset.cartTotal} />
            </RootStore.StoreProvider>,
            gateway
        );
    });
}, 8000);
